// @flow
const timeDiff = [];

export default {
  markStart: (mark: string) => {
    timeDiff[mark] = Date.now();
  },
  markEnd: (mark: string) => Date.now() - timeDiff[mark],
  getMark: (mark: string) => timeDiff[mark]
};
